import React from 'react'
import './Burger.css';
import smallletterA from '../../static/page1-img/small_letterA.svg';
function Burger() {
  return (
    <div className='burger'>
        <div className='burger__section1'>
            <div className='burger__sectio1__top'>
                <img src={smallletterA} alt="letter A"/>
                <p>nshul</p>
            </div>
            <div className='burger__sectio1__down'>
                <p>Full Stack Web Developer</p>
            </div>
        </div>
        <div className='burger__section2'>
            <ul>
                <li><a href='#section_skills'>Skills</a></li>
                <li><a href='#section_projects'>Projects</a></li>
                <li><a href='#section_experience'>My Experience</a></li>
                <li><a href='https://drive.google.com/file/d/1cZUFCZXMEwn7zMoW8bVWKUpyaxYeDx0D/view?usp=drive_link'>Contact</a></li>
            </ul>
        </div>
        
    </div>
  )
}

export default Burger